import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    ClfMeetingContext,
    LOCALSTORAGEKEYS,
} from '../../../../../../_constants/localStorageKeys';
import { roles } from '../../../../../../_constants/roles';
import { CUSTOMCOLUMNEVENT } from '../../../../../../_models/table.model';
import { RoleAccessService } from '../../../../../../_services/_role-access/role-access.service';
import { LocalService } from '../../../../../../_services/_storage/local.service';

@Component({
    selector: 'lokos-custom-action',
    templateUrl: './custom-action.component.html',
    styleUrl: './custom-action.component.scss',
    standalone: false,
})
export class CustomActionComponent {
    @Input() columnDetails: any;
    @Input() rowData: any;
    @Input() entity: any;
    @Output() actioncComponentEvent: EventEmitter<CUSTOMCOLUMNEVENT> =
        new EventEmitter<CUSTOMCOLUMNEVENT>();
    readonly roles = roles;
    loginInfo;
    pastMeetingId: any;

    verificationButtonSelected = '';

    constructor(
        private localService: LocalService,
        public roleAccess: RoleAccessService
    ) {
        this.loginInfo = this.localService.get(LOCALSTORAGEKEYS.USERPROFILE);
        const ctx = this.localService.get<ClfMeetingContext>(
            LOCALSTORAGEKEYS.CLF_MEETING_CONTEXT
        );
        this.pastMeetingId = ctx?.pastMeetingId ?? null;
    }

    onLinkClick() {
        this.actioncComponentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
        });
    }

    onRequestMenuItemClick(code: string) {
        this.actioncComponentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            code: code,
            entity: this.entity,
        });
    }

    onViewClick() {
        this.actioncComponentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
            type: 'view',
        });
    }

    onDeleteClick() {
        this.actioncComponentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
            type: 'delete',
        });
    }
}
